import React, { FC } from 'react';
import { nullSafeGet, renderCurrencyByCurrencyId } from '../../utils/DataAccessUtils';

interface SpotPurchaseItemsCellProps {
	items: any[];
	currencyId: number;
	taxAmount?: number | null;
}

export const SpotPurchaseItemsCell: FC<SpotPurchaseItemsCellProps> = ({
	items,
	currencyId,
	taxAmount,
}) => {
	if ((!items || items.length === 0) && !taxAmount) {
		return <span className="bodyregular text-character-secondary">—</span>;
	}
	return (
		<div className="flex flex-col gap-2">
			{(items || []).map((item, index) => {
				const quantity = nullSafeGet('quantity', item) || 0;
				const name = nullSafeGet('name', item) || nullSafeGet('description', item) || '';
				const unitCost = nullSafeGet('unitCost', item) || 0;
				const perUnit = nullSafeGet('perUnit', item) || nullSafeGet('uomLabel', item) || '';
				const lineTotal = nullSafeGet('totalCost', item) || quantity * unitCost;
				const lineCurrencyId = nullSafeGet('currencyId', item) || currencyId;
				const unitCostDisplay = renderCurrencyByCurrencyId(lineCurrencyId)(unitCost);
				const totalDisplay = renderCurrencyByCurrencyId(lineCurrencyId)(lineTotal);
				const suffix = perUnit ? `@ ${unitCostDisplay} ${perUnit}` : `@ ${unitCostDisplay}`;
				const fullLabel = perUnit
					? `${quantity} ${name} ${suffix}`
					: `${quantity} × ${name} ${suffix}`;
				return (
					<div key={item.id || `line-${index}`} className="flex flex-row items-baseline gap-3">
						<span
							className="bodyregular max-w-[260px] truncate text-character-primary"
							title={fullLabel}
						>
							{perUnit ? `${quantity} ${name} ${suffix}` : `${quantity} × ${name} ${suffix}`}
						</span>
						<span className="min-w-[16px] flex-1 border-x-0 border-b border-t-0 border-dotted border-[#d9d9d9]" />
						<span className="bodyregular whitespace-nowrap text-character-primary">
							{totalDisplay}
						</span>
					</div>
				);
			})}
			{taxAmount ? (
				<div className="flex flex-row items-baseline gap-3">
					<span className="bodyregular whitespace-nowrap text-character-primary">Tax</span>
					<span className="min-w-[16px] flex-1 border-x-0 border-b border-t-0 border-dotted border-[#d9d9d9]" />
					<span className="bodyregular whitespace-nowrap text-character-primary">
						{renderCurrencyByCurrencyId(currencyId)(taxAmount)}
					</span>
				</div>
			) : null}
		</div>
	);
};

export default SpotPurchaseItemsCell;
